import { styles } from "./MainSection";

export const ContactSection = () => (
  <section id="contact" className="contact">
    <div className="container" data-aos="fade-up">
      <div className="section-header">
        <h2>Contact</h2>
        <p>
          Need Help? <span>Contact Us</span>
        </p>
      </div>

      <div className="mb-3">
        <iframe
          title="googleMap"
          style={styles.iFrame}
          src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=7Starr%20Wings9510%20Georgia%20ave,%20Silver%20Spring+(7Starr%20Wings)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
          frameBorder={0}
          allowFullScreen
        ></iframe>
      </div>
      {/*  End Google Maps  */}

      <div className="row gy-4">
        <div className="col-md-6">
          <div className="info-item  d-flex align-items-center">
            <i className="icon bi bi-map flex-shrink-0"></i>
            <div>
              <h3>Our Address</h3>
              <p>9510 Georgia ave, Silver Spring, MD 20902</p>
            </div>
          </div>
        </div>
        {/*  End Info Item  */}

        <div className="col-md-6">
          <div className="info-item d-flex align-items-center">
            <i className="icon bi bi-envelope flex-shrink-0"></i>
            <div>
              <h3>Email Us</h3>
              <p>7starrwings@gmail.com</p>
            </div>
          </div>
        </div>
        {/*  End Info Item  */}

        <div className="col-md-6">
          <div className="info-item  d-flex align-items-center">
            <i className="icon bi bi-telephone flex-shrink-0"></i>
            <a href="tel:+12678881206">
              <div>
                <h3>Call Us</h3>
                <p>267.888.1206</p>
              </div>
            </a>
          </div>
        </div>
        {/*  End Info Item  */}

        <div className="col-md-6">
          <div className="info-item  d-flex align-items-center">
            <i className="icon bi bi-share flex-shrink-0"></i>
            <div>
              <h3>Opening Hours</h3>
              <div>
                <strong>Mon-Sat:</strong> 11AM - 11PM
                <br />
                <strong>Sunday:</strong> Closed
              </div>
            </div>
          </div>
        </div>
        {/*  End Info Item  */}
      </div>

      <form
        action="forms/contact.php"
        method="post"
        className="php-email-form p-3 p-md-4"
      >
        <div className="row">
          <div className="col-xl-6 form-group">
            <input
              type="text"
              name="name"
              className="form-control"
              id="name"
              placeholder="Your Name"
              required
            />
          </div>
          <div className="col-xl-6 form-group">
            <input
              type="email"
              className="form-control"
              name="email"
              id="email"
              placeholder="Your Email"
              required
            />
          </div>
        </div>
        <div className="form-group">
          <input
            type="text"
            className="form-control"
            name="subject"
            id="subject"
            placeholder="Subject"
            required
          />
        </div>
        <div className="form-group">
          <textarea
            className="form-control"
            name="message"
            rows={5}
            placeholder="Message"
            required
          ></textarea>
        </div>
        <div className="my-3">
          <div className="loading">Loading</div>
          <div className="error-message"></div>
          <div className="sent-message">
            Your message has been sent. Thank you!
          </div>
        </div>
        <div className="text-center">
          <button type="submit">Send Message</button>
        </div>
      </form>
      {/*  End Contact Form  */}
    </div>
  </section>
);
